<!--
there is no need to send the day or date in API call, if habit.marked_yesterday is false
 user input is stored for yesterday. Otherwise is stored for today. (Only <span> text is changing)
--->

<template>
  <div>
    <div
      v-if="(!response && !habit.marked) || (habit.marked_yesterday && !habit.marked) || !habit.marked_yesterday"
      class="block-habits"
    >
      <p>
        <strong>{{ __(habit.text) }}</strong>
        <span v-if="!habit.marked_yesterday" v-html="__('Were you able to meet this <strong>yesterday</strong>?')"></span>
        <span v-if="habit.marked_yesterday" v-html="__('Were you able to meet this <strong>today</strong>?')"></span>
      </p>
      <div v-if="!user.is_impersonated">
        <button class="btn btn-white" type="button" @click="complete('success')">
          {{ __('Yes') }}
        </button>
        <button class="btn btn-white" type="button" @click="complete('fail')">
          {{ __('No') }}
        </button>
        <button
          :data-text="habit.tips"
          class="btn-info"
          data-target="#modal-habit-info"
          data-toggle="modal"
          type="button"
        >
          <!-- TODO extract svg-->
          <figure>
            <svg fill="none" height="32" viewBox="0 0 40 40" width="32" xmlns="http://www.w3.org/2000/svg">
              <rect fill="white" fill-opacity="0.2" height="40" rx="10" width="40" />
              <path
                d="M20 30.1641C25.5957 30.1641 30.2051 25.5547 30.2051 19.959C30.2051 14.3633 25.5859 9.74414 20 9.74414C14.4043 9.74414 9.79492 14.3633 9.79492 19.959C9.79492 25.5547 14.4043 30.1641 20 30.1641ZM20 27.8691C15.6152 27.8691 12.0996 24.3438 12.0996 19.959C12.0996 15.5742 15.6055 12.0391 20 12.0391C24.3848 12.0391 27.9102 15.5742 27.9199 19.959C27.9199 24.3438 24.3848 27.8691 20 27.8691ZM19.9707 16.7852C20.7422 16.7852 21.3477 16.1504 21.3477 15.3984C21.3477 14.6172 20.7422 14.002 19.9707 14.002C19.209 14.002 18.584 14.6172 18.584 15.3984C18.584 16.1504 19.209 16.7852 19.9707 16.7852ZM18.2617 25.2129H22.2168C22.6855 25.2129 23.0566 24.8711 23.0566 24.3926C23.0566 23.9434 22.6855 23.582 22.2168 23.582H21.2305V19.2559C21.2305 18.6211 20.918 18.2109 20.3223 18.2109H18.4375C17.9688 18.2109 17.5977 18.5625 17.5977 19.0117C17.5977 19.5 17.9688 19.832 18.4375 19.832H19.3945V23.582H18.2617C17.793 23.582 17.4219 23.9434 17.4219 24.3926C17.4219 24.8711 17.793 25.2129 18.2617 25.2129Z"
                fill="white"
              />
            </svg>
          </figure>
        </button>
      </div>
    </div>

    <div v-else-if="response !== false" class="block-habits">
      <p>
        <strong>{{ __(habit.text) }}</strong>
      </p>
      <div>
        <HabitSucceeded v-if="event === 'success'" :response="response" />
        <HabitFailed v-else :response="response" />
      </div>
    </div>
  </div>
</template>

<script>
  import HabitSucceeded from './HabitSucceeded.vue'
  import HabitFailed from './HabitFailed.vue'

  export default {
    components: {
      HabitSucceeded,
      HabitFailed
    },
    props: {
      habit: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        response: false,
        event: null,
        habitText: null
      }
    },
    mounted() {
      // get results only if the habit was success or fail
      if (this.habit.marked) {
        this.fetchCurrentHistory()
      }
    },
    methods: {
      async complete(event) {
        this.event = event

        await axios.post(
          `/api/habit`,
          { completed: event === 'success' },
          {
            headers: {
              'api-version': 1.2
            }
          }
        )

        if (!this.habit.marked_yesterday) {
          this.habit.marked_yesterday = true
        } else {
          this.habit.marked = true
        }

        await this.fetchCurrentHistory()

        if (event === 'success') {
          Vuemit.fire('Habit-completed--status-success', this.response)
        } else {
          Vuemit.fire('Habit-completed--status-fail', this.response)
        }
      },
      // fetch habit progress history
      async fetchCurrentHistory() {
        this.event = this.habit.pivot.event

        this.response = await axios.get(`/api/habit/history`).thenData()
      }
    }
  }
</script>
